import styled from 'styled-components';
import Color from '@/utils/color';
import Icon from '../../../../../components/Icon';
import { HeaderSmall, ButtonSmall } from '../../../../../components/Text';
import { FLEX_CENTER_CENTER } from '@/utils/styles';

export const AddExtraContainer = styled.div``;

export const ProductOrderSheetDiv = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Color.LightGrey};
`;

export const OrderSheetContainer = styled.div`
  padding: 1rem;
`;

export const LabelContainer = styled.div``;

export const VariantTabs = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.03);
  background: #fff;

  // hide scrollbar
  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  ::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
`;

export const Tab = styled.div`
  ${FLEX_CENTER_CENTER};
  padding: 0.7rem 1rem;
  white-space: nowrap;
  font-size: 0.8rem;
  font-weight: 500;
  color: ${({ active, theme }) =>
    active ? theme.color.primary : theme.color.text};
  border-bottom: 2px solid
    ${({ active, theme }) => (active ? theme.color.primary : 'transparent')};
`;

export const Label = styled.div`
  font-weight: bold;
  color: ${({ theme }) => theme.color.primary};
`;

export const SheetProductDescription = styled.div`
  font-size: 0.7rem;
  color: ${({ theme }) => theme.color.primary};
  padding: 0.5rem;
`;

export const BottomSheetButton = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
`;

export const Spacer = styled.div`
  width: 15px;
`;

export const InheritedExtrasInfoContainer = styled.div`
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid ${Color.Cyan};
  border-radius: 3px;
  font-size: 14px;
`;

export const CounterButton = styled.div`
  padding: 0.5rem;
  margin: 0 2rem;
  color: ${({ theme }) => theme.color.primary};
  border: 1px solid ${({ theme }) => theme.color.primary};
  background: #fff;
`;

export const ExtrasTitle = styled(HeaderSmall)`
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  align-items: center;
  cursor: pointer;
`;

export const ExtrasHighlight = styled(HeaderSmall)`
  color: ${({ theme }) => theme.color.primary};
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
`;

export const StyledIcon = styled.div`
  color: ${({ theme }) => theme.color.primary};
  font-size: 1.2rem;
`;

export const ListContainer = styled.div`
  padding: 0.5rem 0;
  margin-left: 15px;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
`;

export const ExtraDetailsContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
`;

export const ExtraSelectorContainer = styled.div``;

export const ExtraTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ExtraTitle = styled(ButtonSmall)`
  color: ${Color.DarkGrey};
  margin-left: 2rem;
  cursor: pointer;
`;

export const TitleOption = styled.div`
  display: flex;
  align-items: center;
`;

export const ExtraPrice = styled(ButtonSmall)``;

export const InfoIcon = styled(Icon)`
  font-size: 1.5rem;
`;

export const BottomWrapper = styled.div`
  margin-top: 15px;
  flex-direction: column;
  align-items: flex-start;
`;

export const HorizontalSpacer = styled.div`
  height: ${(props) => props.height}px;
`;
